import React from "react"
import "./frames.css"

const SistemaUndercarriage = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">
        Sistema Undercarriage: Optimizando el Espacio en Tratamientos
        Hiperbáricos
      </h1>

      <h2 className="frames-subtitle">
        El Desafío del Espacio en Centros Sanitarios
      </h2>
      <p className="frames-text">
        Uno de los mayores obstáculos en la implementación de cámaras
        hiperbáricas en hospitales y clínicas es la gestión eficiente del
        espacio. En el entorno sanitario, cada metro cuadrado es invaluable.
        Este desafío se amplifica cuando se necesita ubicar múltiples unidades
        de cámaras hiperbáricas en una misma sala.
      </p>

      <h2 className="frames-subtitle">
        Una Solución Innovadora para Ahorrar Espacio
      </h2>

      <h2 className="frames-subsection">El Modelo Estándar</h2>
      <p className="frames-text">
        En los modelos estándar de cámaras hiperbáricas, se necesita un área
        adicional para acomodar el carro de la camilla, que se usa para
        trasladar al paciente dentro y fuera de la cámara durante la terapia de
        oxígeno. Este requisito puede resultar en un uso ineficiente del espacio
        limitado.
      </p>

      <h2 className="frames-subsection">El Sistema Undercarriage de Perry</h2>
      <p className="frames-text">
        Para abordar esta cuestión, Perry Baromedical ha desarrollado un diseño
        de cámara innovador que resuelve este problema de forma ingeniosa. El
        carro de la camilla se ubica en la parte inferior de la cámara,
        liberando espacio valioso en la sala y mejorando la eficiencia
        operativa.
      </p>

      <h2 className="frames-subsection">Ventajas del Sistema</h2>
      <ul className="frames-text">
        <li>
          Optimización del Espacio: Al posicionar el carro de la camilla debajo
          de la cámara, se maximiza el uso del espacio en la sala.
        </li>
        <li>
          Eficiencia Operativa: Este diseño facilita una mejor circulación y
          acceso alrededor de la cámara, lo que simplifica el proceso de
          traslado del paciente.
        </li>
        <li>
          Versatilidad: Este sistema es especialmente beneficioso en salas de
          dimensiones reducidas o cuando se planea instalar más de una unidad de
          cámara hiperbárica.
        </li>
      </ul>

      <h2 className="frames-subsection">Modelos Compatibles</h2>
      <p className="frames-text">
        El sistema Undercarriage está disponible para los modelos SIGMA 34, 36,
        y 40, ofreciendo así una opción de ahorro de espacio en una variedad de
        escenarios clínicos.
      </p>

      <p className="frames-text">
        Con el Sistema Undercarriage, Perry Baromedical continúa demostrando su
        compromiso con la innovación y la excelencia, ofreciendo soluciones que
        satisfacen las necesidades prácticas y espaciales de los entornos
        sanitarios más exigentes.
      </p>
    </div>
  )
}

export default SistemaUndercarriage
